export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'SET_AUDIENCE': {
      return payload;
    }
    default:
      return state;
  }
};
